import React from 'react';

import dayjs from 'dayjs';

import { twMerge } from 'tailwind-merge';

import { createLocale } from 'locales';
import Banner from 'components/banner/banner';

import Typography from 'components/typography/typography';

import { useOrganisationJobDetail } from 'state/context/organization/OrganisationJobDetail';

import getJobHourlyRates from 'utils/get-job-hourly-rates';

import PairText from '../pairtext';

import OrganizationJobInvitedUsersList from './organization-job-invited-users-list';

const localize = createLocale('organizationPlannerJobDetailsLocales');
const globalLocalize = createLocale('global');

const Basis: React.FC = () => {
  const {
    jobContext: { data: job },
  } = useOrganisationJobDetail();

  const jobTarief = getJobHourlyRates(job);
  return (
    <div className="bg-white border-gray200/50 border-2 w-full h-fit pt-4 px-6 pb-8 font-roboto flex flex-col flex-wrap gap-5 rounded-md">
      <div className="w-full flex justify-between">
        <Typography variant="body-large-bold" as="p">
          {localize('basis')}
        </Typography>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
        <PairText Title={localize('date')} Value={job.date} />
        <PairText
          Title={localize('time')}
          Value={`${dayjs(job.start, 'HH:mm:ss').format('HH:mm')} - ${dayjs(
            job.end,
            'HH:mm:ss',
          ).format('HH:mm')}`}
        />
        <PairText
          Title={localize('pause')}
          Value={globalLocalize('minute', { count: job.pause })}
        />
        <PairText Title={localize('location')} Value={job.location.name} />
        <PairText
          Title={localize('assignmentType')}
          Value={twMerge(
            job.is_interest && globalLocalize('interest'),
            job.is_personal && globalLocalize('personal'),
            job.is_urgent && !job.is_personal && globalLocalize('urgent'),
          )}
        />
        <div className="flex flex-wrap flex-col gap-2">
          <Typography
            as="p"
            variant="body-medium-bold"
            className="text-gray400/60 text-xs font-semibold"
          >
            {localize('status')}
          </Typography>
          <Banner
            title={
              job.assigned_to
                ? globalLocalize('assigned')
                : globalLocalize('open')
            }
            variants={job.assigned_to ? 'success' : 'danger'}
            className="px-2 py-3 w-fit"
            typographyClassName="text-center"
          />
        </div>
        <PairText Title={globalLocalize('hourlyRate')} Value={jobTarief} />
        <PairText Title={localize('competencies')} Value={job.competence} />
        <PairText
          Title={localize('orderCreated')}
          Value={dayjs(job.created_at).format('DD MMMM YYYY')}
        />
        <PairText Title={localize('madeBy')} Value={job.organisation.name} />
        <div className="col-span-2 md:col-span-3 lg:col-span-6">
          <PairText Title={localize('comments')} Value={job.remarks} />
        </div>
      </div>

      <OrganizationJobInvitedUsersList />
    </div>
  );
};

export default Basis;
